import * as React from "react";
function SvgLoadDown(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M46.8 33.1c-.7 0-1.2.5-1.2 1.2v6.8c0 .6-.5 1-1 1h-41c-.5.1-1.1-.3-1.2-.8v-7c0-.7-.5-1.2-1.2-1.2S0 33.6 0 34.3v6.8c0 1.9 1.5 3.4 3.4 3.4h41c1.9.1 3.5-1.3 3.6-3.2v-7c0-.7-.5-1.2-1.2-1.2zm-23.7-4.8c.5.5 1.2.5 1.7 0l7.4-7.4c.4-.5.4-1.3-.1-1.7-.4-.4-1.1-.4-1.6 0l-5.4 5.4V4.7c0-.7-.5-1.2-1.2-1.2s-1.1.5-1.1 1.2v19.8l-5.4-5.4c-.4-.5-1.2-.6-1.7-.1-.5.4-.6 1.2-.1 1.7l.1.1 7.4 7.5z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgLoadDown);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
